import React from 'react';

import { SidebarFiltersSection } from 'components/sidebar-filters';
import { CheckboxGroup } from 'components/core';

import { useSpecialsFilter } from './use-specials-filter';

export function SpecialsFilter(): JSX.Element | null {
  const { options, selectedFilters, handleSelection, heading } = useSpecialsFilter();

  if (options.length === 0) {
    return null;
  }

  return (
    <SidebarFiltersSection startsOpen heading={heading}>
      <CheckboxGroup options={options} selectedOptions={selectedFilters} onSelect={handleSelection} />
    </SidebarFiltersSection>
  );
}
